import { serverUrl } from "../config";

const registerApi = async (uid) => {
  try {
    const res = await fetch(`${serverUrl}/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        data: { clientId: uid },
      }),
    });

    if (res.ok) {
      const jsonData = await res.json();
      return {
        clientId: jsonData["clientId"],
        currentBalance: jsonData["data"]["currentBalance"],
        //session
        numOfCells: jsonData["data"]["numOfCells"],
        currentMultiplier: jsonData["data"]["currentMultiplier"],
        nextMultiplier: jsonData["data"]["nextMultiplier"],
        openedCounter: jsonData["data"]["openedCounter"],
        minesCounter: jsonData["data"]["minesCounter"],
        betValue: jsonData["data"]["betValue"],
        openedIndexes: jsonData["data"]["openedIndexes"],
      };
    }
  } catch (e) {
    console.error(e);
  }
};
export default registerApi;
